import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=622dd512&scoped=true&"
import script from "./rename.vue?vue&type=script&lang=js&"
export * from "./rename.vue?vue&type=script&lang=js&"
import style0 from "./rename.vue?vue&type=style&index=0&id=622dd512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622dd512",
  null
  
)

component.options.__file = "rename.vue"
export default component.exports